import { all } from 'redux-saga/effects';
import wizard from "./wizard";
export default function* root() {
    yield all([
        wizard(),
    ]);
}
